// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__3EKbi"};